





















import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import VModal from "./VModal.vue";
import Broadcast from "@/models/SpecialInitiatives/Broadcast";
import SpecialInitiativesMixin from "@/mixins/http/SpecialInitiatives";
import BroadcastModuleItem from "@/components/SpecialInitiatives/Broadcast/BroadcastModuleItem.vue";

@Component({
  components: {
    VModal,
    BroadcastModuleItem,
  },
})
export default class BroadcastModal extends Vue {
  @Prop({ default: "Dettaglio programma" }) readonly title?: string;
  @Prop({ default: 0 }) readonly totalWeeklySeconds?: number;
  @Prop({ required: true }) readonly broadcast?: Broadcast;

  modal!: VModal;
  content = "";

  confirmed!: Function | null;
  canceled!: Function | null;

  async mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  get hasContent(): boolean {
    return this.$slots.default != null;
  }

  get broadcastName(): string {
    if (this.broadcast) {
      return this.broadcast.name;
    }
    return "";
  }

  get broadcastModules() {
    if (this.broadcast) {
      return this.broadcast.broadcastModules;
    }
    return [];
  }

  get broadcastTotalDuration() {
    let counter = 0;
    this.broadcastModules.forEach((broadcastModule) => {
      counter +=
        broadcastModule.module.spotDuration.seconds *
        broadcastModule.timeSlots.length *
        broadcastModule.days.length;
    });
    return counter;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
  }

  protected onConfirm() {
    if (this.confirmed) {
      this.confirmed();
    }

    this.confirmed = null;
    this.modal.hide();
  }

  protected onHidden() {
    if (this.canceled) {
      this.canceled();
    }
  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  confirm(content: string | undefined = undefined): Promise<boolean> {
    this.modal.show();

    if (content) {
      this.content = content;
    }

    return new Promise((resolve) => {
      this.confirmed = () => {
        resolve(true);
      };

      this.canceled = () => {
        resolve(false);
      };
    });
  }
}
